import React, { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import RoleSelection from "../../components/Auth/RoleSelectionForm/RoleSelectionForm";
import RegistrationForm from "../../components/Auth/RegistrationForm/RegistrationForm";
import LoginForm from "../../components/Auth/LoginForm/LoginForm";
import LoginViaCodeForm from "../../components/Auth/LoginViaCodeForm/LoginViaCodeForm";
import ResetPasswordForm from "../../components/Auth/ResetPasswordForm/ResetPasswordForm";
import OtpVerificationForm from "../../components/Auth/OtpVerificationForm/OtpVerificationForm";
import "./AuthPage.css";
import PasswordOtpVerificationForm from "../../components/Auth/PasswordOtpVerificationForm/PasswordOtpVerificationForm";
import { Button } from "@mui/material";

const AuthPage = () => {
  const { token, role, status } = useContext(AuthContext);
  const [currentStep, setCurrentStep] = React.useState("role"); // role, register, otp, login, reset-password
  const [selectedRole, setSelectedRole] = React.useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const scrollableElement = document.querySelector('#root') || document.documentElement;
    scrollableElement.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);
  

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const skipRegistration = params.get("skipRegistration") === "true";

    if (skipRegistration) {
      setCurrentStep("login"); // Skip to login step
    }
  }, [location]);

  useEffect(() => {
    if (token && role) {
      if (status === "active") {
        navigate('/dashboard')
      } else {
        navigate(`/`);
      }
    }
  }, [status]);

  return (
    <div className="auth-page">
      <div className="form-container">
      {currentStep === "role" && (
        <RoleSelection setRole={setSelectedRole} setCurrentStep={setCurrentStep} />
      )}
      {currentStep === "register" && (
        <RegistrationForm role={selectedRole} setCurrentStep={setCurrentStep} />
      )}
      {currentStep === "otp" && <OtpVerificationForm setCurrentStep={setCurrentStep} />}
      {currentStep === "passwordOtp" && <PasswordOtpVerificationForm setCurrentStep={setCurrentStep} />}
      {currentStep === "login" && <LoginForm setCurrentStep={setCurrentStep} />}
      {currentStep === "login-via-code" && <LoginViaCodeForm setCurrentStep={setCurrentStep} />}
      {currentStep === "reset-password" && <ResetPasswordForm setCurrentStep={setCurrentStep} />}
      {currentStep !== 'login' && currentStep !== 'login-via-code' &&
          <Button
            onClick={() => setCurrentStep("login")}
            className="member-button"
          >
            Already a member? Login instead
          </Button>
        }
      {(currentStep === 'login' || currentStep === 'login-via-code') &&
          <Button
            onClick={() => setCurrentStep("role")}
            className="member-button"
          >
            Don't have an account? Register Now
          </Button>
        }
    </div>
    </div>
  );
};

export default AuthPage;
